import React from 'react';
import Background from 'src/components/CE/Background';

const AnchorNav = () => {
  return (
    <nav id="nav-anchor">
      <Background styleName="rainbow">
        <div className="container">
          <div>Projekte</div>
        </div>
      </Background>
      <Background styleName="black">
        <div className="container">
          <div className="text-center">Interaktion</div>
        </div>
      </Background>
      <Background styleName="gray-stripes">
        <div className="container">
          <div>Aktuelles</div>
        </div>
      </Background>
    </nav>
  );
};

export default AnchorNav;
